import { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { getResult, getResultAnswers } from 'store/player/playerAsync';
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';
import QuizTypes from 'types/QuizTypes';
// Components
import PublicDevicePlayable from 'components/PublicDevicePlayable';
import AppBar from 'components/AppBar';
import TopBuckets from './TopBuckets';
import ProceedData from './ProceedData';
import LeaderboardButton from './LeaderboardButton';
import PoweredBy from 'components/PoweredBy';

const PostQuizPage:FC = () => {
  const { slug } = useParams<{ slug:string }>();
  const navigateTo = useNavigateTo();
  // Dispatch
  const dispatch = useAppDispatch();
  
  const result = useAppSelector(selectResult);
  const quiz = useAppSelector(selectQuiz);
  const isPollQuiz = quiz.type === QuizTypes.Poll;
  const isSurveyQuiz = quiz.type === QuizTypes.Survey;
  const isSurveyOrPersonalityQuiz = [QuizTypes.Personality, QuizTypes.Survey].includes(quiz.type);

  useEffect(() => {
    if (isPollQuiz) {
      dispatch(getResultAnswers({ quizName: slug }));
    } else if (!isSurveyQuiz) {
      dispatch(getResult({ quizName: slug, limit: 96 }));
    }
    if (!quiz.callToAction.enabled && !isSurveyOrPersonalityQuiz) {
      if (isPollQuiz) {
        navigateTo('results');
      } else {
        navigateTo('leaderboard');
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if ( result && result.quiz ){
      // Set default primary
      document.documentElement.style.setProperty('--primaryColor', result.quiz.theme.primaryColor);
      document.documentElement.style.setProperty('--primaryFontColor', result.quiz.theme.primaryFontColor);
      document.documentElement.style.setProperty('--primaryButtonGradientStart', result.quiz.theme.primaryButtonGradientStart);
      document.documentElement.style.setProperty('--primaryButtonGradientEnd', result.quiz.theme.primaryButtonGradientEnd);
      document.documentElement.style.setProperty('--primaryButtonFontColor', result.quiz.theme.primaryButtonFontColor);
    }
    // eslint-disable-next-line
  }, [result])

  if (!quiz.callToAction.enabled && !isSurveyOrPersonalityQuiz) return null;
  return (
    <>
    <PublicDevicePlayable />
      <div
        className="h-full flex flex-col"
        style={{ background: quiz.postQuizBackgroundImage ? `url('${quiz.postQuizBackgroundImage}') top / cover` : '' }}
      >
        <div className="p-4"><AppBar /></div>
        <div
          className="flex-1 flex flex-col p-4 overflow-y-auto"
        >
          {isPollQuiz || quiz.type === QuizTypes.Survey ? (
            <div className="h-5/6 px-4 flex flex-col items-center justify-center">
              <h2 className="font-bold text-center text-primary text-3xl mb-8">{quiz.callToAction.headerText}</h2>
              {quiz.callToAction.image ? (
                <img
                  className="relative z-10 shadow-primary rounded-lg"
                  src={quiz.callToAction.image}
                  alt=""
                />
              ) : null}
            </div>
          ) : null}
          <LeaderboardButton />
          <ProceedData />
          <TopBuckets />
        </div>
        <PoweredBy />
      </div>
    </>
  )
}

export default PostQuizPage;
